// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clicks-1{fill:#faedb1}.clicks-2{fill:#1e4e69}.clicks-3{fill:#a6b1b9}\n", "",{"version":3,"sources":["webpack://./src/components/images/clicks.css"],"names":[],"mappings":"AAAA,UAAU,YAAY,CAAC,UAAU,YAAY,CAAC,UAAU,YAAY","sourcesContent":[".clicks-1{fill:#faedb1}.clicks-2{fill:#1e4e69}.clicks-3{fill:#a6b1b9}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
